<template>    
  <div class="col-2 p-2 mb-2 bg-secondary text-white">
    <b-form-checkbox v-model="toggleStatus" >Toggle all</b-form-checkbox>
  </div>
</template>

<script>
import {
  mapState
} from 'vuex';

export default {
  name: 'ToggleAllButton',
  computed: {
    toggleStatus: {
      get () {
        return this.$store.state.searchForm.toggleStatus[this.fieldsPrefix];
      },
      set (value) {
      if(value != null){
        var payload = {
          prefix: this.fieldsPrefix,
          booleanValue: value
        }
        this.$store.commit('setToggleStatus', payload);
      }
     }
    }
  },
  props: {
    fieldsPrefix: {
      type: String,
      default: ''
    }
  }
}
</script>

